const state = {
    state: {
        loading: false,
        message: ''
    },
    mutations: {
        loading(state, {message, loadingState}) {
            state.message = message
            state.loading = loadingState
        }
    },
    actions: {
        startLoading({commit}, message) {
            commit('loading', {message, loadingState: true})
        },
        stopLoading({commit}) {
            commit('loading', {message: '', loadingState: false})
        }
    },
    getters: {
        loading(state) {
            return state.loading
        },
        loadingMessage(state) {
            return state.message
        }
    }
}

export default state
